// extracted by mini-css-extract-plugin
export var box = "style-module--box--654ca";
export var box_info = "style-module--box_info--ad1d9";
export var box_title = "style-module--box_title--3b639";
export var box_wrap = "style-module--box_wrap--32c2a";
export var how_we_do_content = "style-module--how_we_do_content--b75f2";
export var how_we_do_section = "style-module--how_we_do_section--903d1";
export var icon_wrap = "style-module--icon_wrap--a0f03";